<template>
  <div class="common">
    <div class="insurebox">
      <img class="insuretitle" src="@/assets/img2/venuetwo-insuretitle.png" alt="">
      <div v-for="(item, index) in insureList" :key="index" class="insureList" @click="proClick(item)">
        <img class="insureImg" :src="item.img" alt="">
        <div class="info">
          <div class="insureName">{{ item.title }}</div>
          <div class="insureDes">{{ item.info }}</div>
          <div class="priceBox">
            <div>
              <template v-if="item.price">
                ￥{{ item.price }} <span style="font-size: 12px;color: #505050;">元起</span>
              </template>
            </div>
            <div class="detailBtn">立即选购</div>
          </div>
        </div>
      </div>
    </div>

    <img class="zs" src="@/assets/img2/venueone-fdbottom.png" alt="">

    <div class="jfdhbox" id="jfdl">
      <img class="jfdhtitle" src="@/assets/img2/venuetwo-jfdhtitle.png" alt="">
      <div class="jfdhtop">
        <div class="topitem wkdh">
          <div>我可兑换</div>
          <div class="check"> <van-icon name="success" class="checkicon" /> </div>
        </div>
        <div class="topitem wddh">
          <img class="jfdhtitle" src="@/assets/img2/venuetwo-gift.png" alt="">
          <div>我的兑换</div>
        </div>
      </div>
      <div class="jfdhcon">
        <div class="proLi" v-for="(item, i) in productList" :key="i">
          <img class="proImg" :src="item.img" alt="">
          <div class="proName">{{ item.name }}</div>
          <div class="jfbox">
            <div class="jf">{{ item.jf }} <span>积分</span></div>
            <div class="dh" @click="dhFn(item)">兑换</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 兑换弹框 -->
    <van-popup v-model="dhPopupShow" position="bottom" :close-on-click-overlay="false" class="custom-popup-dh">
      <img class="proimg" src="@/assets/img2/pro1.png" alt="">
      <div class="proname">{{ dhPro.name }}</div>
      <div class="jfbox">
        <img class="jficon" :src="dhPro.img" alt=""></img>
        <div>{{ dhPro.jf }}积分</div>
      </div>
      <div class="btnbox">
        <div class="btn" @click="dhPopupShow = false">取消</div>
        <div class="btn btn2" @click="lidhFn">立即兑换</div>
      </div>
    </van-popup>

    <!-- 兑换结果 -->
    <van-popup v-model="dhjgPopupShow" position="center" :close-on-click-overlay="false" class="custom-popup-gzh">
      <template v-if="dhresult == 'success'">
        <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
        <div class="popup-content">
          <img class="titleimg" src="@/assets/img2/home-popup-title4.png" alt="">
          <div class="message">恭喜您兑换成功！奖品已成功发放到【会员中心】的卡券中，您可从活动页中的【积分兑换】</div>
          <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="dhjgPopupShow = false">
        </div>
      </template>
      <template v-else>
        <img class="topimg" src="@/assets/img2/home-popup-top2.png" alt="">
        <div class="popup-content">
          <img class="titleimg" src="@/assets/img2/home-popup-title5.png" alt="">
          <div class="message">很抱歉您的积分不足，请再努力做任务攒积分吧~</div>
          <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="dhjgPopupShow = false">
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      insureList: [
        {
          img: require('@/assets/img2/insure1.png'),
          title: '无忧保plus百万医疗保险（互联网专属）',
          info: '保障全保费低 多人价格实惠',
          price: '188',
          path: process.env.VUE_APP_ZKING_PROPAGEONE
        },
        {
          img: require('@/assets/img2/insure2.png'),
          title: '月享安康保（互联网版）',
          info: '涵盖意外身故残疾保障',
          price: '25',
          path: process.env.VUE_APP_ZKING_PROPAGETWO
        },
      ],
      productList: [
        {
          img: require('@/assets/img2/pro1.png'),
          name: '彪马男帽女帽遮阳刺绣黑 色棒球帽鸭舌帽',
          jf: '52',
        },
        {
          img: require('@/assets/img2/pro1.png'),
          name: '彪马男帽女帽遮阳刺绣黑 色棒球帽鸭舌帽',
          jf: '52',
        },
        {
          img: require('@/assets/img2/pro1.png'),
          name: '彪马男帽女帽遮阳刺绣黑 色棒球帽鸭舌帽',
          jf: '52',
        },
        {
          img: require('@/assets/img2/pro1.png'),
          name: '彪马男帽女帽遮阳刺绣黑 色棒球帽鸭舌帽',
          jf: '52',
        },
      ],

      dhPro: {},
      dhPopupShow: false,
      dhjgPopupShow: false,
      dhresult: 'success',
    }
  },
  created() { },
  mounted() { },

  methods: {
    dhFn(item) {
      this.dhPro = { ...item }
      this.dhPopupShow = true
    },
    lidhFn() {
      // this.dhPro
      this.dhPopupShow = false
      this.dhresult = 'success'
      this.dhjgPopupShow = true
    },

    scrollFn() {
      const element = document.querySelector("#jfdl")
      window.scrollTo({
        top: element.offsetTop, // 滚动到该元素距离文档顶部的距离
        behavior: 'smooth'            // 关键：启用平滑滚动动画
      });
    },
  },

  beforeDestroy() {
  },
}
</script>

<style lang="less" scoped>
.common {
  display: flex;
  flex-direction: column;
  align-items: center;

  .insurebox {
    margin-top: 12px;
    width: 330px;
    padding: 0 13px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #FFF6BF 0%, #FFFFFF 29.47%);
    border-radius: 18px 18px 18px 18px;

    .insuretitle {
      width: 100%;
      margin-bottom: 27px;
    }

    .insureList {
      display: flex;
      margin-bottom: 20px;
      padding: 0 4px;

      .insureImg {
        width: 95px;
        height: 80px;
        border-radius: 6px;
        margin-right: 10px;
      }

      .info {
        width: calc(100% - 105px);
        display: flex;
        flex-direction: column;
        align-items: space-between;
        justify-content: space-between;

        .insureName {
          font-weight: 500;
          font-size: 13px;
          color: #313035;
        }

        .insureDes {
          margin-top: 2px;
          font-size: 11px;
          color: #98979C;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .priceBox {
          font-weight: 500;
          font-size: 16px;
          color: #7E3FEB;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .detailBtn {
            font-size: 12px;
            color: #FFFFFF;

            width: 63px;
            height: 26px;
            background: linear-gradient(180deg, #FFC466 0%, #FD8F00 100%);
            border-radius: 13px 13px 13px 13px;

            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 0;
            padding: 0 8px;
          }
        }
      }
    }
  }

  .zs {
    width: 100%;
    margin-top: -17px;
  }

  .jfdhbox {
    width: 100%;
    margin-top: -2px;
    background: #FFF5CB;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 13px;
    box-sizing: border-box;


    .jfdhtitle {
      width: 193px;

    }

    .jfdhtop {
      width: 100%;
      padding: 10px 13px 12px 13px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .topitem {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #9B0600;
      }

      .wkdh {
        font-weight: 500;

        .check {
          width: 13px;
          height: 13px;
          margin: 2px 0 0 4px;
          border-radius: 3px 3px 3px 3px;
          border: 1px solid #9B0600;
          display: flex;
          justify-content: center;
          align-items: center;

          .checkicon {
            font-size: 16px;
            color: #9B0600;
          }
        }
      }

      .wddh {
        background: #FFFDC7;
        border-radius: 19px 19px 19px 19px;
        border: 1px solid #FF9E30;
        padding: 3px 12px;

        img {
          width: 25px;
          height: 25px;
          margin-right: 6px;
        }
      }
    }

    .jfdhcon {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .proLi {
        width: 170px;
        border-radius: 10px;
        margin-bottom: 10px;
        background: #FFFFFF;

        .proImg {
          width: 100%;
          height: 173px;
        }

        .proName {
          padding: 5px 9px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 14px;
          color: #212121;
        }

        .jfbox {
          padding: 4px 9px 12px 9px;
          display: flex;
          justify-content: space-between;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;

          .jf {
            font-size: 16px;
            color: #F86142;

            span {
              font-size: 10px;
            }
          }

          .dh {
            width: 49px;
            height: 23px;
            background: linear-gradient(180deg, #FFC466 0%, #FD8F00 100%);
            border-radius: 6px 6px 6px 6px;
            font-size: 12px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }

  .custom-popup-dh {
    border-radius: 20px 20px 0 0;
    background: linear-gradient(180deg, #EBC2FE 0%, #FFFFFF 25.11%, #FFFFFF 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    padding: 30px 0 40px 0;

    .proimg {
      width: 150px;
      height: 150px;
    }

    .proname {
      font-weight: 500;
      font-size: 20px;
      color: #3B3B3B;
      margin: 16px 0;
      padding: 0 40px;
      text-align: center;
    }

    .jfbox {
      width: 124px;
      height: 39px;
      background: #FFF7B4;
      border-radius: 22px 22px 22px 22px;
      position: relative;
      padding-left: 30px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 18px;
      color: #FF9F30;

      .jficon {
        width: 53px;
        height: 53px;
        position: absolute;
        top: -10px;
        left: -10px;
      }
    }

    .btnbox {
      display: flex;
      margin-top: 25px;

      .btn {
        width: 151px;
        height: 45px;
        background: #EFEFEF;
        border-radius: 11px 11px 11px 11px;
        font-weight: 500;
        font-size: 16px;
        color: #636363;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 8px;
      }

      .btn2 {
        color: #FFFFFF;
        background: linear-gradient(0deg, #B25BFF 0%, #D081FF 100%);
      }
    }
  }

  .custom-popup-gzh {
    .popup-content {
      .titleimg {
        width: 118px;
      }

      .message {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 16px;
        color: #3B3B3B;
        padding: 0 28px;
        text-align: justify;
        margin: 30px 0;
      }
    }
  }
}
</style>
